(() => {
  function setup(root, savedDisclosure) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const disclosure = root.querySelector('[data-filter-disclosure]');
    const controls = root.querySelector('.vq-catalog__filter-controls');
    if (disclosure) {
      disclosure.open = savedDisclosure ?? history.state?.vqCatalogOpen ?? !matchMedia('(max-width: 700px)').matches;
      disclosure.addEventListener('toggle', () => {
        history.replaceState({ ...history.state, vqCatalogOpen: disclosure.open }, '', location.href);
      });
    }
    const cards = [...root.querySelectorAll('[data-card]')];
    const select = root.querySelector('[data-texture]');
    const material = root.querySelector('[data-material]');
    const initialUrl = new URL(location.href);
    const legacyFamily = initialUrl.searchParams.get('view')?.replace('vq-', '');
    const collectionFamily = initialUrl.pathname.match(/\/collections\/(raw|virgin)-hair(?:\/|$)/)?.[1];
    const requestedMaterial = collectionFamily || initialUrl.searchParams.get('material') || legacyFamily;
    if (['raw', 'virgin'].includes(requestedMaterial)) material.value = requestedMaterial;
    const categoryValues = ['', 'wigs', 'bundles', 'braiding', 'extensions', 'samples'];
    const requestedCategory = initialUrl.searchParams.get('category') || (legacyFamily ? location.hash.slice(1) : '');
    let category = categoryValues.includes(requestedCategory) ? requestedCategory : '';
    const count = root.querySelector('[data-count]');
    const empty = root.querySelector('[data-empty]');
    const complete = root.dataset.complete === 'true';
    let pending;
    async function updateCollection(url, focusSelector) {
      pending?.abort();
      const controller = new AbortController();
      pending = controller;
      root.setAttribute('aria-busy', 'true');
      if (controls) controls.inert = true;
      const error = root.querySelector('[data-filter-error]');
      if (error) error.hidden = true;
      try {
        const response = await fetch(url.href, { signal: controller.signal });
        if (!response.ok) throw new Error('Catalog request failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = page.querySelector('[data-vq-catalog]');
        if (controller.signal.aborted) return;
        if (!next) throw new Error('Catalog response missing');
        const position = { left: scrollX, top: scrollY, behavior: 'instant' };
        const open = disclosure?.open;
        history.replaceState(history.state, '', url);
        root.replaceWith(next);
        setup(next, open);
        next.querySelector(focusSelector)?.focus({ preventScroll: true });
        window.scrollTo(position);
      } catch (cause) {
        if (cause.name === 'AbortError') return;
        material.value = collectionFamily || initialUrl.searchParams.get('material') || '';
        if (error) error.hidden = false;
      } finally {
        if (pending === controller) {
          root.removeAttribute('aria-busy');
          if (controls) controls.inert = false;
        }
      }
    }
    const normalize = value => String(value).trim().replace(/\s+/g, ' ');
    const allTextures = new Map();
    cards.forEach(card => {
      const textures = [];
      try {
        const options = JSON.parse(card.dataset.options || '[]');
        options.filter(option => option.name.toLowerCase() === 'texture').forEach(option => {
          option.values.forEach(value => textures.push(normalize(typeof value === 'string' ? value : value.name)));
        });
        const description = new DOMParser().parseFromString(card.dataset.description || '', 'text/html');
        description.querySelectorAll('dt').forEach(term => {
          if (term.textContent.trim().toLowerCase().replace(/:$/, '') === 'texture' && term.nextElementSibling?.tagName === 'DD') {
            textures.push(normalize(term.nextElementSibling.textContent));
          }
        });
        const tags = JSON.parse(card.dataset.tags || '[]');
        if (!textures.length && tags.includes('texture-body-wave')) textures.push('Body Wave');
        if (!textures.length && tags.includes('source-phf-17897')) textures.push('Burmese Curly');
      } catch {}
      card.vqTextures = textures.filter(Boolean).map(value => {
        const key = value.toLowerCase();
        allTextures.set(key, value);
        return key;
      });
    });
    function filter() {
      let total = 0;
      cards.forEach(card => {
        card.hidden = Boolean((select.value && !card.vqTextures.includes(select.value)) || (category && card.dataset.format !== category) || (material.value && ![material.value, 'both'].includes(card.dataset.family)));
        if (!card.hidden) total++;
      });
      if (complete) count.textContent = `${total} ${total === 1 ? root.dataset.oneProduct : root.dataset.manyProducts}`;
      empty.hidden = total > 0;
      const url = new URL(location.href);
      if (select.value) url.searchParams.set('texture', select.value);
      else url.searchParams.delete('texture');
      if (material.value) url.searchParams.set('material', material.value); else url.searchParams.delete('material');
      if (category) url.searchParams.set('category', category); else url.searchParams.delete('category');
      root.querySelectorAll('[data-category]').forEach(link => {
        const target = new URL(link.href);
        const targetSupportsMaterial = cards.some(card => card.dataset.format === link.dataset.category && [material.value, 'both'].includes(card.dataset.family));
        if (material.value && (!link.dataset.category || targetSupportsMaterial)) target.searchParams.set('material', material.value); else target.searchParams.delete('material');
        if (select.value) target.searchParams.set('texture', select.value); else target.searchParams.delete('texture');
        link.href = target.href;
        if (link.dataset.category === category) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current');
      });
      history.replaceState(history.state, '', url);
      document.querySelectorAll('a[href*="/customer_authentication/login"]').forEach(link => {
        const login = new URL(link.href, location.origin);
        if (login.origin !== location.origin || login.pathname !== '/customer_authentication/login') return;
        const returnTo = new URL(location.href);
        if (link.hasAttribute('data-gift-login')) returnTo.searchParams.set('vq_gift', 'claim');
        login.searchParams.set('return_to', returnTo.pathname + returnTo.search);
        link.href = login.href;
      });
    }
    if (complete && allTextures.size) {
      [...allTextures].sort((a,b) => a[1].localeCompare(b[1])).forEach(([value,label]) => select.add(new Option(label, value)));
      root.querySelector('.vq-catalog__texture').hidden = false;
      const requested = new URL(location.href).searchParams.get('texture');
      if (requested && allTextures.has(requested)) select.value = requested;
      select.addEventListener('change', filter);
    }
    root.querySelector('[data-clear]').addEventListener('click', () => { select.value = ''; material.value = collectionFamily || ''; category = ''; filter(); });
    root.querySelectorAll('[data-category]').forEach(link => link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (complete && !collectionFamily) {
        category = link.dataset.category;
        filter();
      } else updateCollection(new URL(link.href), `[data-category="${link.dataset.category}"]`);
    }));
    material.addEventListener('change', () => {
      if (collectionFamily) {
        const target = new URL(location.href);
        target.pathname = material.value ? '/collections/' + material.value + '-hair' : '/collections/all';
        target.searchParams.delete('material');
        target.searchParams.delete('page');
        updateCollection(target, '[data-material]');
      } else filter();
    });
    filter();
  }
  document.querySelectorAll('[data-vq-catalog]').forEach(root => setup(root));
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vq-catalog]').forEach(root => setup(root)));
})();

